"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var window_or_global_1 = __importDefault(require("window-or-global"));
var setupNav = function (observerFn, configFn) {
    if (window_or_global_1.default._epicGamesNavObserverCreated) {
        if (observerFn && typeof observerFn === 'function') {
            observerFn();
        }
    }
    else if (!window_or_global_1.default._egNavAfterConfigSetCalled) {
        var prevSet_1;
        if (window_or_global_1.default._egNavAfterConfigSet && typeof window_or_global_1.default._egNavAfterConfigSet === 'function') {
            prevSet_1 = window_or_global_1.default._egNavAfterConfigSet;
        }
        window_or_global_1.default._egNavAfterConfigSet = function () {
            if (configFn && typeof configFn === 'function') {
                configFn();
            }
            if (prevSet_1)
                prevSet_1.apply(this);
        };
    }
    else {
        setTimeout(function () {
            setupNav(observerFn, configFn);
        }, 250);
    }
};
exports.setupNav = setupNav;
var navReady = function (callbackFn) {
    var prevReady;
    if (window_or_global_1.default._egNavReadyCallback && typeof window_or_global_1.default._egNavReadyCallback === 'function') {
        prevReady = window_or_global_1.default._egNavReadyCallback;
    }
    window_or_global_1.default._egNavReadyCallback = function () {
        if (callbackFn && typeof callbackFn === 'function') {
            callbackFn();
        }
        if (prevReady)
            prevReady.apply(this);
    };
};
exports.navReady = navReady;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2hlYWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHNFQUFvQztBQU9wQyxJQUFNLFFBQVEsR0FBRyxVQUFDLFVBQVUsRUFBRSxRQUFRO0lBQ2xDLElBQUksMEJBQUksQ0FBQyw0QkFBNEIsRUFBRTtRQUNuQyxJQUFJLFVBQVUsSUFBSSxPQUFPLFVBQVUsS0FBSyxVQUFVLEVBQUU7WUFDaEQsVUFBVSxFQUFFLENBQUM7U0FPaEI7S0FDSjtTQUFNLElBQUksQ0FBQywwQkFBSSxDQUFDLDBCQUEwQixFQUFFO1FBQ3pDLElBQUksU0FBTyxDQUFDO1FBQ1osSUFBSSwwQkFBSSxDQUFDLG9CQUFvQixJQUFJLE9BQU8sMEJBQUksQ0FBQyxvQkFBb0IsS0FBSyxVQUFVLEVBQUU7WUFDOUUsU0FBTyxHQUFHLDBCQUFJLENBQUMsb0JBQW9CLENBQUM7U0FDdkM7UUFFRCwwQkFBSSxDQUFDLG9CQUFvQixHQUFHO1lBQ3hCLElBQUksUUFBUSxJQUFJLE9BQU8sUUFBUSxLQUFLLFVBQVUsRUFBRTtnQkFDNUMsUUFBUSxFQUFFLENBQUM7YUFPZDtZQUNELElBQUksU0FBTztnQkFBRSxTQUFPLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ3JDLENBQUMsQ0FBQztLQUNMO1NBQU07UUFFSCxVQUFVLENBQUM7WUFDUCxRQUFRLENBQUMsVUFBVSxFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBQ25DLENBQUMsRUFBRSxHQUFHLENBQUMsQ0FBQztLQUNYO0FBQ0wsQ0FBQyxDQUFDO0FBZ0JNLDRCQUFRO0FBZGhCLElBQU0sUUFBUSxHQUFHLFVBQUEsVUFBVTtJQUN2QixJQUFJLFNBQVMsQ0FBQztJQUNkLElBQUksMEJBQUksQ0FBQyxtQkFBbUIsSUFBSSxPQUFPLDBCQUFJLENBQUMsbUJBQW1CLEtBQUssVUFBVSxFQUFFO1FBQzVFLFNBQVMsR0FBRywwQkFBSSxDQUFDLG1CQUFtQixDQUFDO0tBQ3hDO0lBRUQsMEJBQUksQ0FBQyxtQkFBbUIsR0FBRztRQUN2QixJQUFJLFVBQVUsSUFBSSxPQUFPLFVBQVUsS0FBSyxVQUFVLEVBQUU7WUFDaEQsVUFBVSxFQUFFLENBQUM7U0FDaEI7UUFDRCxJQUFJLFNBQVM7WUFBRSxTQUFTLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3pDLENBQUMsQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVnQiw0QkFBUSJ9